import { styled } from "@material-ui/styles";

import TableCell from "@material-ui/core/TableCell";
import colors from "../../assets/style/colors";

const TableCellStyled = styled(TableCell)({
  fontSize: "1em",
  color: colors.black87,
  height: "50px",
  boxSizing: "border-box",
  padding: "5px 8px !important",
  borderBottom: "none",
});

export default TableCellStyled;
